import React from 'react';
import ReactDOM from 'react-dom';
import './styles/app.sass';
import i18next from 'i18next';
import Router from './scripts/components/Router/';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { GlobalStateProvider } from './scripts/contexts/GlobalStateContext';

import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.handleRedirectPromise().catch((error) => {
	console.error('Redirect promise error:', error);
});

i18next.init({
	interpolation: { escapeValue: false }, // React already does escaping
});

ReactDOM.render(
	<React.StrictMode>
		<MsalProvider instance={msalInstance} >
			<GlobalStateProvider>
				<BrowserRouter>
					<Router />
				</BrowserRouter>
			</GlobalStateProvider>
		</MsalProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

document.getElementById('root').classList.add('page-container');
document.documentElement.lang = i18next.language;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
